export default {
  data() {
    return {
      searchSchema: [
        {
          label: '角色名称',
          itemName: 'name',
          type: 'input',
          allowClear: true,
        },
        {
          label: '添加时间',
          itemName: 'times',
          type: 'rangePicker',
          format: 'YYYY-MM-DD',
          allowClear: true,
        },
      ],
      searchData: {
        name: '',
        startTime: '',
        endTime: '',
        times: '',
      },
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          fixed: 'left',
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
          // scopedSlots: { customRender: 'order'}
        },
        {
          title: '角色名称',
          dataIndex: 'name',
        },
        {
          title: '角色描述',
          dataIndex: 'description',
        },
        {
          title: '权限级别',
          dataIndex: 'permissionLevelName',
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          fixed: 'right',
          width: 120,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
